import { useCallback } from 'react';
import { useLocalStorage } from 'services/hooks';
import { ModelView, ModelViewsSelectorProps } from './ModelViewsSelector.props';
import { MainContainer, ViewButtonContainer, ViewsContainer } from './ModelViewsSelector.styles';
import ViewButtonWithTooltip from './ViewButtonWithTooltip';
import { ACTIVE_MODEL_VIEW_KEY, MODELS_VIEWS_KEY } from '../common/constants';

const ModelViewsSelector = ({ onLoadView, currentViewId, views: externalViews }: ModelViewsSelectorProps) => {
  const [internalViews] = useLocalStorage<ModelView[]>(MODELS_VIEWS_KEY, []);
  const [, setActiveModelView] = useLocalStorage<ModelView | null>(ACTIVE_MODEL_VIEW_KEY, null);
  const views = externalViews ?? internalViews;

  const handleLoadView = useCallback((event: React.MouseEvent<HTMLButtonElement>, savedView: ModelView) => {
    event.stopPropagation();
    onLoadView(savedView);
    setActiveModelView(savedView);
  }, [onLoadView, setActiveModelView]);

  return (
    <MainContainer sx={{ ml: 1 }}>
      <ViewsContainer>
        {views.map(savedView => (
          <ViewButtonContainer key={savedView.id}>
            <ViewButtonWithTooltip 
              savedView={savedView} 
              currentViewId={currentViewId}
              onClick={handleLoadView}
            />
          </ViewButtonContainer>
        ))}
      </ViewsContainer>
    </MainContainer>
  );
};

export default ModelViewsSelector;